import React from "react";
import { Routes, Route } from "react-router-dom";
import { Background } from "./Background";
import "./global.css";

import SignIn from "./components/Forms/SignIn";
import SignUp from "./components/Forms/SignUp";
import ForgotPassword from "./components/Forms/ForgotPassword";
import ChangePassword from "./components/Forms/ChangePassword";

export const Auth = ({ onLogin }) => {
  return (
    <div className="relative min-h-screen flex flex-col lg:flex-row items-center justify-center bg-white">
      <Background />

      <div className="relative z-20 w-full lg:w-1/2 px-4">
        <Routes>
          <Route index path="/" element={<SignIn onLogin={onLogin} />} />
          <Route path="/company_sign_in" element={<SignIn onLogin={onLogin} />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/changepassword" element={<ChangePassword />} />
        </Routes>
      </div>
    </div>
  );
};
